let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4pkKO")).then(() => parcelRequire('77zn3'));